/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

const dayOfWeekConverter = {
    0: 'Sunday',
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday',
};

const monthConverter = {
    '01': 'Jan',
    '02': 'Feb',
    '03': 'Mar',
    '04': 'Apr',
    '05': 'May',
    '06': 'Jun',
    '07': 'Jul',
    '08': 'Aug',
    '09': 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Dec',
};

// This function converts an object that we get back from our delivery calendar API
// into a format used with Apple Pay

export const applePayDateConverter = (dateArray, baseShippingCharge = '0.00') => {  // eslint-disable-line import/prefer-default-export
    const resultsArr = dateArray.map((dateObj) => {
        const fullDeliveryDate = dateObj.deliveryDate.split('-');
        const newDateFormat = new Date(
            fullDeliveryDate[0],
            fullDeliveryDate[1] - 1,
            fullDeliveryDate[2],
        );
        const dayOfWeek = dayOfWeekConverter[newDateFormat.getDay()];
        const month = monthConverter[fullDeliveryDate[1]];
        const label = `${dayOfWeek} - ${month} ${newDateFormat.getDate()} ${
            fullDeliveryDate[0]
        }`;
        // const intAmount = Number(baseShippingCharge) + Number(dateObj.surcharge) + Number(dateObj.baseCharge);
        // const amount = intAmount.toFixed(2);
        // replace the following line with the commented ones above it to display accurate total shipping.
        // instead of just base shipping charge
        const amount = baseShippingCharge;
        // const amount = `${Number(dateObj.surcharge) +
        //     Number(dateObj.baseCharge)}`;
        let additionalDetails;
        if (Number(dateObj.surcharge) > 0) {
            additionalDetails = ` + $${dateObj.surcharge}`;
        } else {
            additionalDetails = '';
        }
        const detail = `Std. Shipping${additionalDetails}`;
        const identifier = `day=${fullDeliveryDate[2]}&month=${
            fullDeliveryDate[1]
        }&year=${fullDeliveryDate[0]}&deliverySLA=${dateObj.deliverySLA}`;
        return {
            label,
            amount,
            detail,
            identifier,
        };
    });
    return resultsArr;
};
